export const dataBook = {
  1: [[{ imgUrl: "img/FriendsPlus/ListPage/bia.jpg", excerciseNum: 0 }]],
  2: [[{ imgUrl: "img/FriendsPlus/ListPage/1.jpg", excerciseNum: 0 }]],
  3: [[{ imgUrl: "img/FriendsPlus/ListPage/2.jpg", excerciseNum: 0 }]],
  4: [[{ imgUrl: "img/FriendsPlus/ListPage/3.jpg", excerciseNum: 0 }]],
  5: [[{ imgUrl: "img/FriendsPlus/ListPage/4.jpg", excerciseNum: 0 }]],

  // 6: [
  //   [{ imgUrl: "img/FriendsPlus/Page6/1.jpg", excerciseNum: 3 }],
  //   [{ imgUrl: "img/FriendsPlus/Page6/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page6/3.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page6/4.jpg", excerciseNum: 0 }],
  // ],
  // 7: [
  //   [{ imgUrl: "img/FriendsPlus/Page7/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/3.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page7/4.jpg", excerciseNum: 0 }],
  // ],
  // 8: [
  //   [{ imgUrl: "img/FriendsPlus/Page8/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/3.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/4.jpg", excerciseNum: 3 }],
  //   [{ imgUrl: "img/FriendsPlus/Page8/5.jpg", excerciseNum: 0 }],
  // ],
  // 9: [
  //   [{ imgUrl: "img/FriendsPlus/Page9/1.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/2.jpg", excerciseNum: 1 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/3.jpg", excerciseNum: 0 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/4.jpg", excerciseNum: 2 }],
  //   [{ imgUrl: "img/FriendsPlus/Page9/5.jpg", excerciseNum: 0 }],
  // ],
  6: [[{ imgUrl: "img/FriendsPlus/ListPage/6.jpg", excerciseNum: 0 }]],
  7: [[{ imgUrl: "img/FriendsPlus/ListPage/7.jpg", excerciseNum: 0 }]],
  8: [[{ imgUrl: "img/FriendsPlus/ListPage/8.jpg", excerciseNum: 0 }]],
  9: [[{ imgUrl: "img/FriendsPlus/ListPage/9.jpg", excerciseNum: 0 }]],
  10: [[{ imgUrl: "img/FriendsPlus/ListPage/10.jpg", excerciseNum: 0 }]],
  11: [[{ imgUrl: "img/FriendsPlus/ListPage/11.jpg", excerciseNum: 0 }]],
  12: [[{ imgUrl: "img/FriendsPlus/ListPage/12.jpg", excerciseNum: 0 }]],
  13: [[{ imgUrl: "img/FriendsPlus/ListPage/13.jpg", excerciseNum: 0 }]],
  14: [[{ imgUrl: "img/FriendsPlus/ListPage/14.jpg", excerciseNum: 0 }]],
  15: [[{ imgUrl: "img/FriendsPlus/ListPage/15.jpg", excerciseNum: 0 }]],
  16: [[{ imgUrl: "img/FriendsPlus/ListPage/16.jpg", excerciseNum: 0 }]],
  17: [[{ imgUrl: "img/FriendsPlus/ListPage/17.jpg", excerciseNum: 0 }]],
  18: [[{ imgUrl: "img/FriendsPlus/ListPage/18.jpg", excerciseNum: 0 }]],
  19: [[{ imgUrl: "img/FriendsPlus/ListPage/19.jpg", excerciseNum: 0 }]],
  20: [[{ imgUrl: "img/FriendsPlus/ListPage/20.jpg", excerciseNum: 0 }]],
  21: [[{ imgUrl: "img/FriendsPlus/ListPage/21.jpg", excerciseNum: 0 }]],
  22: [[{ imgUrl: "img/FriendsPlus/ListPage/22.jpg", excerciseNum: 0 }]],

  23: [
    [{ imgUrl: "img/FriendsPlus/Page23/1.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page23/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page23/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page23/4.jpg", excerciseNum: 0 }],
  ],
  24: [
    [{ imgUrl: "img/FriendsPlus/Page24/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page24/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page24/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page24/4.jpg", excerciseNum: 0 }],
  ],
  25: [
    [{ imgUrl: "img/FriendsPlus/Page25/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page25/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page25/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page25/4.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page25/5.jpg", excerciseNum: 0 }],
  ],
  26: [
    [{ imgUrl: "img/FriendsPlus/Page26/1.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page26/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page26/3.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page26/4.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page26/5.jpg", excerciseNum: 0 }],
  ],
  27: [
    [{ imgUrl: "img/FriendsPlus/Page27/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page27/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page27/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page27/4.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page27/5.jpg", excerciseNum: 0 }],
  ],
  28: [
    [{ imgUrl: "img/FriendsPlus/Page28/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page28/2.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page28/3.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page28/4.jpg", excerciseNum: 4 }],
    [{ imgUrl: "img/FriendsPlus/Page28/5.jpg", excerciseNum: 0 }],
  ],
  29: [
    [{ imgUrl: "img/FriendsPlus/Page29/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page29/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page29/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page29/4.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page29/5.jpg", excerciseNum: 0 }],
  ],

  30: [[{ imgUrl: "img/FriendsPlus/ListPage/30.jpg", excerciseNum: 0 }]],
  31: [
    [{ imgUrl: "img/FriendsPlus/Page31/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page31/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page31/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page31/4.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page31/5.jpg", excerciseNum: 4 }],
    [{ imgUrl: "img/FriendsPlus/Page31/6.jpg", excerciseNum: 0 }],
  ],
  32: [
    [{ imgUrl: "img/FriendsPlus/Page32/1.jpg", excerciseNum: 0 }],
    [{ imgUrl: "img/FriendsPlus/Page32/2.jpg", excerciseNum: 1 }],
    [{ imgUrl: "img/FriendsPlus/Page32/3.jpg", excerciseNum: 2 }],
    [{ imgUrl: "img/FriendsPlus/Page32/4.jpg", excerciseNum: 3 }],
    [{ imgUrl: "img/FriendsPlus/Page32/5.jpg", excerciseNum: 4 }],
    [{ imgUrl: "img/FriendsPlus/Page32/6.jpg", excerciseNum: 0 }],
  ],
  33: [[{ imgUrl: "img/FriendsPlus/ListPage/33.jpg", excerciseNum: 0 }]],
  34: [[{ imgUrl: "img/FriendsPlus/ListPage/34.jpg", excerciseNum: 0 }]],
  35: [[{ imgUrl: "img/FriendsPlus/ListPage/35.jpg", excerciseNum: 0 }]],
  36: [[{ imgUrl: "img/FriendsPlus/ListPage/36.jpg", excerciseNum: 0 }]],
  37: [[{ imgUrl: "img/FriendsPlus/ListPage/37.jpg", excerciseNum: 0 }]],
  38: [[{ imgUrl: "img/FriendsPlus/ListPage/38.jpg", excerciseNum: 0 }]],
  39: [[{ imgUrl: "img/FriendsPlus/ListPage/39.jpg", excerciseNum: 0 }]],

  40: [[{ imgUrl: "img/FriendsPlus/ListPage/40.jpg", excerciseNum: 0 }]],
  41: [[{ imgUrl: "img/FriendsPlus/ListPage/41.jpg", excerciseNum: 0 }]],
  42: [[{ imgUrl: "img/FriendsPlus/ListPage/42.jpg", excerciseNum: 0 }]],
  43: [[{ imgUrl: "img/FriendsPlus/ListPage/43.jpg", excerciseNum: 0 }]],
  44: [[{ imgUrl: "img/FriendsPlus/ListPage/44.jpg", excerciseNum: 0 }]],
  45: [[{ imgUrl: "img/FriendsPlus/ListPage/45.jpg", excerciseNum: 0 }]],
  46: [[{ imgUrl: "img/FriendsPlus/ListPage/46.jpg", excerciseNum: 0 }]],
  47: [[{ imgUrl: "img/FriendsPlus/ListPage/47.jpg", excerciseNum: 0 }]],
  48: [[{ imgUrl: "img/FriendsPlus/ListPage/48.jpg", excerciseNum: 0 }]],
  49: [[{ imgUrl: "img/FriendsPlus/ListPage/49.jpg", excerciseNum: 0 }]],
  50: [[{ imgUrl: "img/FriendsPlus/ListPage/50.jpg", excerciseNum: 0 }]],
  51: [[{ imgUrl: "img/FriendsPlus/ListPage/51.jpg", excerciseNum: 0 }]],
  52: [[{ imgUrl: "img/FriendsPlus/ListPage/52.jpg", excerciseNum: 0 }]],
  53: [[{ imgUrl: "img/FriendsPlus/ListPage/53.jpg", excerciseNum: 0 }]],
  54: [[{ imgUrl: "img/FriendsPlus/ListPage/54.jpg", excerciseNum: 0 }]],
  55: [[{ imgUrl: "img/FriendsPlus/ListPage/55.jpg", excerciseNum: 0 }]],
  56: [[{ imgUrl: "img/FriendsPlus/ListPage/56.jpg", excerciseNum: 0 }]],
  57: [[{ imgUrl: "img/FriendsPlus/ListPage/57.jpg", excerciseNum: 0 }]],
  58: [[{ imgUrl: "img/FriendsPlus/ListPage/58.jpg", excerciseNum: 0 }]],
  59: [[{ imgUrl: "img/FriendsPlus/ListPage/59.jpg", excerciseNum: 0 }]],
  60: [[{ imgUrl: "img/FriendsPlus/ListPage/60.jpg", excerciseNum: 0 }]],
  61: [[{ imgUrl: "img/FriendsPlus/ListPage/61.jpg", excerciseNum: 0 }]],
  62: [[{ imgUrl: "img/FriendsPlus/ListPage/62.jpg", excerciseNum: 0 }]],
  63: [[{ imgUrl: "img/FriendsPlus/ListPage/63.jpg", excerciseNum: 0 }]],
  64: [[{ imgUrl: "img/FriendsPlus/ListPage/64.jpg", excerciseNum: 0 }]],
  65: [[{ imgUrl: "img/FriendsPlus/ListPage/65.jpg", excerciseNum: 0 }]],
  66: [[{ imgUrl: "img/FriendsPlus/ListPage/66.jpg", excerciseNum: 0 }]],
  67: [[{ imgUrl: "img/FriendsPlus/ListPage/67.jpg", excerciseNum: 0 }]],
  68: [[{ imgUrl: "img/FriendsPlus/ListPage/68.jpg", excerciseNum: 0 }]],
  69: [[{ imgUrl: "img/FriendsPlus/ListPage/69.jpg", excerciseNum: 0 }]],
  70: [[{ imgUrl: "img/FriendsPlus/ListPage/70.jpg", excerciseNum: 0 }]],
  71: [[{ imgUrl: "img/FriendsPlus/ListPage/71.jpg", excerciseNum: 0 }]],
  72: [[{ imgUrl: "img/FriendsPlus/ListPage/72.jpg", excerciseNum: 0 }]],
  73: [[{ imgUrl: "img/FriendsPlus/ListPage/73.jpg", excerciseNum: 0 }]],
  74: [[{ imgUrl: "img/FriendsPlus/ListPage/74.jpg", excerciseNum: 0 }]],
  75: [[{ imgUrl: "img/FriendsPlus/ListPage/75.jpg", excerciseNum: 0 }]],
  76: [[{ imgUrl: "img/FriendsPlus/ListPage/76.jpg", excerciseNum: 0 }]],
  77: [[{ imgUrl: "img/FriendsPlus/ListPage/77.jpg", excerciseNum: 0 }]],
  78: [[{ imgUrl: "img/FriendsPlus/ListPage/78.jpg", excerciseNum: 0 }]],
  79: [[{ imgUrl: "img/FriendsPlus/ListPage/79.jpg", excerciseNum: 0 }]],
  80: [[{ imgUrl: "img/FriendsPlus/ListPage/80.jpg", excerciseNum: 0 }]],
  81: [[{ imgUrl: "img/FriendsPlus/ListPage/81.jpg", excerciseNum: 0 }]],
  82: [[{ imgUrl: "img/FriendsPlus/ListPage/82.jpg", excerciseNum: 0 }]],
  83: [[{ imgUrl: "img/FriendsPlus/ListPage/83.jpg", excerciseNum: 0 }]],
  84: [[{ imgUrl: "img/FriendsPlus/ListPage/84.jpg", excerciseNum: 0 }]],
  85: [[{ imgUrl: "img/FriendsPlus/ListPage/85.jpg", excerciseNum: 0 }]],
  86: [[{ imgUrl: "img/FriendsPlus/ListPage/86.jpg", excerciseNum: 0 }]],
  87: [[{ imgUrl: "img/FriendsPlus/ListPage/87.jpg", excerciseNum: 0 }]],
  88: [[{ imgUrl: "img/FriendsPlus/ListPage/88.jpg", excerciseNum: 0 }]],
  89: [[{ imgUrl: "img/FriendsPlus/ListPage/89.jpg", excerciseNum: 0 }]],
  90: [[{ imgUrl: "img/FriendsPlus/ListPage/90.jpg", excerciseNum: 0 }]],
  91: [[{ imgUrl: "img/FriendsPlus/ListPage/91.jpg", excerciseNum: 0 }]],
  92: [[{ imgUrl: "img/FriendsPlus/ListPage/92.jpg", excerciseNum: 0 }]],
  93: [[{ imgUrl: "img/FriendsPlus/ListPage/93.jpg", excerciseNum: 0 }]],
  94: [[{ imgUrl: "img/FriendsPlus/ListPage/94.jpg", excerciseNum: 0 }]],
  95: [[{ imgUrl: "img/FriendsPlus/ListPage/95.jpg", excerciseNum: 0 }]],
  96: [[{ imgUrl: "img/FriendsPlus/ListPage/96.jpg", excerciseNum: 0 }]],
  97: [[{ imgUrl: "img/FriendsPlus/ListPage/97.jpg", excerciseNum: 0 }]],
  98: [[{ imgUrl: "img/FriendsPlus/ListPage/98.jpg", excerciseNum: 0 }]],
  99: [[{ imgUrl: "img/FriendsPlus/ListPage/99.jpg", excerciseNum: 0 }]],

  100: [[{ imgUrl: "img/FriendsPlus/ListPage/100.jpg", excerciseNum: 0 }]],
  101: [[{ imgUrl: "img/FriendsPlus/ListPage/101.jpg", excerciseNum: 0 }]],
  102: [[{ imgUrl: "img/FriendsPlus/ListPage/102.jpg", excerciseNum: 0 }]],
  103: [[{ imgUrl: "img/FriendsPlus/ListPage/103.jpg", excerciseNum: 0 }]],
  104: [[{ imgUrl: "img/FriendsPlus/ListPage/104.jpg", excerciseNum: 0 }]],
  105: [[{ imgUrl: "img/FriendsPlus/ListPage/105.jpg", excerciseNum: 0 }]],
  106: [[{ imgUrl: "img/FriendsPlus/ListPage/106.jpg", excerciseNum: 0 }]],
  107: [[{ imgUrl: "img/FriendsPlus/ListPage/107.jpg", excerciseNum: 0 }]],
  108: [[{ imgUrl: "img/FriendsPlus/ListPage/108.jpg", excerciseNum: 0 }]],
  109: [[{ imgUrl: "img/FriendsPlus/ListPage/109.jpg", excerciseNum: 0 }]],
  110: [[{ imgUrl: "img/FriendsPlus/ListPage/110.jpg", excerciseNum: 0 }]],
  111: [[{ imgUrl: "img/FriendsPlus/ListPage/111.jpg", excerciseNum: 0 }]],
  112: [[{ imgUrl: "img/FriendsPlus/ListPage/112.jpg", excerciseNum: 0 }]],
  113: [[{ imgUrl: "img/FriendsPlus/ListPage/113.jpg", excerciseNum: 0 }]],
  114: [[{ imgUrl: "img/FriendsPlus/ListPage/114.jpg", excerciseNum: 0 }]],
  115: [[{ imgUrl: "img/FriendsPlus/ListPage/115.jpg", excerciseNum: 0 }]],
  116: [[{ imgUrl: "img/FriendsPlus/ListPage/116.jpg", excerciseNum: 0 }]],
  117: [[{ imgUrl: "img/FriendsPlus/ListPage/117.jpg", excerciseNum: 0 }]],
  118: [[{ imgUrl: "img/FriendsPlus/ListPage/118.jpg", excerciseNum: 0 }]],
  119: [[{ imgUrl: "img/FriendsPlus/ListPage/119.jpg", excerciseNum: 0 }]],
  120: [[{ imgUrl: "img/FriendsPlus/ListPage/120.jpg", excerciseNum: 0 }]],
  121: [[{ imgUrl: "img/FriendsPlus/ListPage/121.jpg", excerciseNum: 0 }]],
  122: [[{ imgUrl: "img/FriendsPlus/ListPage/122.jpg", excerciseNum: 0 }]],
  123: [[{ imgUrl: "img/FriendsPlus/ListPage/123.jpg", excerciseNum: 0 }]],
  124: [[{ imgUrl: "img/FriendsPlus/ListPage/124.jpg", excerciseNum: 0 }]],
  125: [[{ imgUrl: "img/FriendsPlus/ListPage/125.jpg", excerciseNum: 0 }]],
  126: [[{ imgUrl: "img/FriendsPlus/ListPage/126.jpg", excerciseNum: 0 }]],
  127: [[{ imgUrl: "img/FriendsPlus/ListPage/127.jpg", excerciseNum: 0 }]],
  128: [[{ imgUrl: "img/FriendsPlus/ListPage/128.jpg", excerciseNum: 0 }]],
  129: [[{ imgUrl: "img/FriendsPlus/ListPage/129.jpg", excerciseNum: 0 }]],
  130: [[{ imgUrl: "img/FriendsPlus/ListPage/130.jpg", excerciseNum: 0 }]],
  131: [[{ imgUrl: "img/FriendsPlus/ListPage/131.jpg", excerciseNum: 0 }]],
  132: [[{ imgUrl: "img/FriendsPlus/ListPage/132.jpg", excerciseNum: 0 }]],
  133: [[{ imgUrl: "img/FriendsPlus/ListPage/133.jpg", excerciseNum: 0 }]],
};
